import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "danger" | "ghost";
type Size = "sm" | "md";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  children: ReactNode;
}

const VARIANT_CLASSES: Record<Variant, string> = {
  primary:
    "bg-brand-600 text-white border border-transparent hover:bg-brand-700 focus-visible:ring-brand-500",
  secondary:
    "bg-surface text-text border border-surface-border hover:bg-surface-muted focus-visible:ring-brand-500",
  danger:
    "bg-danger-700 text-white border border-transparent hover:bg-danger-500 focus-visible:ring-danger-500",
  ghost:
    "bg-transparent text-text border border-transparent hover:bg-surface-muted focus-visible:ring-brand-500",
};

const SIZE_CLASSES: Record<Size, string> = {
  sm: "h-8 px-3 text-body gap-1.5",
  md: "h-10 px-4 text-body gap-2",
};

export function Button({
  variant = "secondary",
  size = "md",
  className = "",
  type = "button",
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={[
        "inline-flex items-center justify-center rounded-md font-medium transition-colors",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        VARIANT_CLASSES[variant],
        SIZE_CLASSES[size],
        className,
      ].join(" ")}
      {...rest}
    >
      {children}
    </button>
  );
}
